import { connect } from 'react-redux';
import Commissions from './Commissions';
import { getAppointmentsViewData } from 'state/actions/actions';

export default connect(null, { getAppointmentsViewData })(Commissions);
